import { render, staticRenderFns } from "./UserEventVkBtn.vue?vue&type=template&id=12641084"
import script from "./UserEventVkBtn.vue?vue&type=script&lang=ts"
export * from "./UserEventVkBtn.vue?vue&type=script&lang=ts"
import style0 from "./UserEventVkBtn.vue?vue&type=style&index=0&id=12641084&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppIcon: require('/builds/project/wyffest/frontend/components/app/AppIcon.vue').default,AppBtn: require('/builds/project/wyffest/frontend/components/app/AppBtn.vue').default})
